var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 195 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6794_511240)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6794_511240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.82 8.55542V50.6366C103.82 52.4105 104.136 53.6333 104.769 54.3049C105.402 54.9765 106.442 55.3152 107.888 55.3211C108.634 55.3324 109.378 55.2724 110.112 55.1419C110.606 55.0602 111.084 54.9058 111.531 54.6838V60.2112C110.624 60.6218 109.669 60.9245 108.689 61.1128C107.634 61.3263 106.56 61.4346 105.484 61.4359C102.228 61.4359 99.8338 60.6086 98.302 58.9541C96.7702 57.2996 96.0053 54.7454 96.0073 51.2915V8.55542H103.82Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6794_511240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.035 60.9837H119.237V25.0173H127.035V60.9837ZM123.166 18.9847C121.463 18.9847 120.164 18.5647 119.267 17.7247C118.374 16.8877 117.918 15.7012 117.918 14.1651C117.918 12.6291 118.365 11.4572 119.267 10.6407C120.168 9.82425 121.463 9.41895 123.166 9.41895C124.818 9.41895 126.094 9.82621 126.993 10.6407C127.892 11.4553 128.341 12.6301 128.341 14.1651C128.341 15.7021 127.892 16.8887 126.993 17.7247C126.094 18.5608 124.818 18.9808 123.166 18.9847Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6794_511240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.672 8.32919C155.987 8.32919 157.446 8.53478 158.318 8.88134V15.0314C157.371 14.7876 156.402 14.639 155.425 14.5879C153.431 14.5879 152.425 15.0431 151.282 15.9536C150.139 16.8641 149.571 18.3531 149.571 20.4149V25.6574L149.788 27.5988V60.9835H141.99V19.8392C141.962 18.1714 142.246 16.5127 142.827 14.9462C143.354 13.5525 144.217 12.3065 145.342 11.3161C146.518 10.3007 147.897 9.54029 149.389 9.084C151.099 8.56193 152.882 8.30724 154.672 8.32919ZM157.38 31.0585H135.136V25.0172H157.392L157.38 31.0585Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6794_511240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.768 20.1272C182.877 20.1272 185.489 20.6167 187.604 21.5957C189.719 22.5747 191.322 23.8816 192.414 25.5166C193.497 27.1106 194.068 28.9897 194.054 30.9089C194.085 32.3216 193.838 33.727 193.327 35.0471C192.887 36.1484 192.244 37.1601 191.432 38.0311C190.691 38.8203 189.799 39.4563 188.807 39.9019C187.914 40.3195 186.95 40.5685 185.964 40.6362V40.7067C188.237 40.7012 190.44 41.4769 192.196 42.9006C193.062 43.6188 193.759 44.5149 194.238 45.5263C194.768 46.6773 195.029 47.9308 195.003 49.1946C195.003 51.74 194.334 53.9339 192.997 55.7764C191.585 57.6791 189.665 59.1583 187.452 60.0497C185.095 61.0541 182.386 61.5573 179.324 61.5593C175.582 61.5593 172.29 60.7555 169.449 59.148C166.608 57.5405 164.524 55.0832 163.199 51.7762L170.342 48.6835C170.876 50.8373 171.884 52.5016 173.366 53.6764C174.848 54.8512 176.832 55.4386 179.318 55.4386C180.804 55.4803 182.282 55.2111 183.655 54.6486C184.773 54.179 185.734 53.406 186.426 52.4194C187.094 51.4163 187.438 50.2363 187.411 49.036C187.411 47.0251 186.767 45.587 185.479 44.7215C184.191 43.8561 182.207 43.4244 179.527 43.4263C179.13 43.4263 178.692 43.4381 178.214 43.4616C177.726 43.488 177.241 43.5232 176.756 43.5702V38.037C177.118 38.0846 177.483 38.1091 177.848 38.1104H178.869C181.448 38.1104 183.356 37.6209 184.592 36.6419C185.828 35.6629 186.447 34.164 186.449 32.1454C186.449 30.2755 185.842 28.8246 184.628 27.7927C183.414 26.7609 181.696 26.2449 179.476 26.2449C177.19 26.2449 175.405 26.7481 174.119 27.7546C172.833 28.761 171.995 30.1991 171.604 32.069L164.607 29.552C165.19 27.6181 166.241 25.8532 167.669 24.4093C169.143 22.9553 170.94 21.8593 172.916 21.208C175.12 20.4709 177.435 20.1064 179.762 20.1301",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_6794_511240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.56 49.7468L15.5629 66.0001H5.09253L28.7953 4.00317H34.8876H40.98L64.6797 66.0001H53.9236L34.7894 12.6438L24.4143 41.5761L21.56 49.7468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28286 57.8264H0V66.0001H8.28286V57.8264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4975 6.52305C41.4975 10.1267 28.2771 10.1267 28.2771 6.52305C28.2771 4.79303 28.9735 3.13387 30.2132 1.91056C31.4529 0.687248 33.1342 0 34.8873 0C36.6405 0 38.3218 0.687248 39.5615 1.91056C40.8011 3.13387 41.4975 4.79303 41.4975 6.52305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8046 57.8264H61.5217V66.0001H69.8046V57.8264Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6794_511240",
    x: 91.0073,
    y: 8.55542,
    width: 25.5242,
    height: 62.8804,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6794_511240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6794_511240",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6794_511240",
    x: 112.918,
    y: 9.41895,
    width: 20.4229,
    height: 61.5647,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6794_511240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6794_511240",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6794_511240",
    x: 130.136,
    y: 8.32788,
    width: 33.1819,
    height: 62.6558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6794_511240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6794_511240",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6794_511240",
    x: 158.199,
    y: 20.1272,
    width: 41.8059,
    height: 51.4321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6794_511240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6794_511240",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_6794_511240",
    x: -5,
    y: 0,
    width: 79.8047,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6794_511240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6794_511240",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6794_511240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifBrand);
export default __webpack_public_path__ + "static/media/lif-brand.b2da0603e1426d66b9bf7be946494b9c.svg";
export { ForwardRef as ReactComponent };